// @flow

import React from 'react';
import { Field } from 'redux-form';
import { withPhone, withRequired } from '../../validators';
import type { RequiredProps } from '../../validators/withRequired';
import { ReduxFormLabeledInput } from '../../../form/labeledFields';

type OwnProps = {
  label: string,
  name: string,
  placeholder?: string,
  validate?: Array<Function>,
};

type Props = OwnProps;

const PhoneField = ({
  label,
  name,
  placeholder,
  validate,
}: Props) => (
  <Field
    component={ReduxFormLabeledInput}
    label={label}
    name={name}
    placeholder={placeholder}
    type="tel"
    validate={validate}
  />
);

PhoneField.defaultProps = {
  placeholder: '',
  validate: [],
};

export default withPhone<Props & RequiredProps>(withRequired(PhoneField));
